/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentDeliveryPlans } from 'app/entities/treatment-delivery-plan/treatment-delivery-plan.reducer';
import { getEntities as getTreatmentCycles } from 'app/entities/treatment-cycle/treatment-cycle.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getTreatmentRegimen } from 'app/entities/treatment-regimen/treatment-regimen.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-adverse-event.reducer';

export const TreatmentAdverseEventUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentDeliveryPlans = useAppSelector(state => state.treatmentDeliveryPlan.entities);
  const treatmentCycles = useAppSelector(state => state.treatmentCycle.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const treatmentRegimen = useAppSelector(state => state.treatmentRegimen.entities);
  const treatmentAdverseEventEntity = useAppSelector(state => state.treatmentAdverseEvent.entity);
  const loading = useAppSelector(state => state.treatmentAdverseEvent.loading);
  const updating = useAppSelector(state => state.treatmentAdverseEvent.updating);
  const updateSuccess = useAppSelector(state => state.treatmentAdverseEvent.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-adverse-event${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentDeliveryPlans({}));
    dispatch(getTreatmentCycles({}));
    dispatch(getClinicalDictionaries({}));
    dispatch(getTreatmentRegimen({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.eventDate !== undefined && typeof values.eventDate !== 'number') {
      values.eventDate = Number(values.eventDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentAdverseEventEntity,
      ...values,
      plan: treatmentDeliveryPlans.find(it => it.id.toString() === values.plan?.toString()),
      cycles: treatmentCycles.find(it => it.id.toString() === values.cycles?.toString()),
      eventType: clinicalDictionaries.find(it => it.id.toString() === values.eventType?.toString()),
      eventResult: clinicalDictionaries.find(it => it.id.toString() === values.eventResult?.toString()),
      regimen: treatmentRegimen.find(it => it.id.toString() === values.regimen?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentAdverseEventEntity,
          plan: treatmentAdverseEventEntity?.plan?.id,
          cycles: treatmentAdverseEventEntity?.cycles?.id,
          eventType: treatmentAdverseEventEntity?.eventType?.id,
          eventResult: treatmentAdverseEventEntity?.eventResult?.id,
          regimen: treatmentAdverseEventEntity?.regimen?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentAdverseEvent.home.createOrEditLabel" data-cy="TreatmentAdverseEventCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.home.createOrEditLabel">
              Create or edit a TreatmentAdverseEvent
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-adverse-event-id"
                  label={translate('tinyMedicRestApp.treatmentAdverseEvent.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.eventDate')}
                id="treatment-adverse-event-eventDate"
                name="eventDate"
                data-cy="eventDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.eventDescription')}
                id="treatment-adverse-event-eventDescription"
                name="eventDescription"
                data-cy="eventDescription"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.severity')}
                id="treatment-adverse-event-severity"
                name="severity"
                data-cy="severity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.impactedParameters')}
                id="treatment-adverse-event-impactedParameters"
                name="impactedParameters"
                data-cy="impactedParameters"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.mitigationStrategiesTaken')}
                id="treatment-adverse-event-mitigationStrategiesTaken"
                name="mitigationStrategiesTaken"
                data-cy="mitigationStrategiesTaken"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.active')}
                id="treatment-adverse-event-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.cursor')}
                id="treatment-adverse-event-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.lastUpdated')}
                id="treatment-adverse-event-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.microSec')}
                id="treatment-adverse-event-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.timestampEntry')}
                id="treatment-adverse-event-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-adverse-event-plan"
                name="plan"
                data-cy="plan"
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.plan')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentDeliveryPlans
                  ? treatmentDeliveryPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-adverse-event-cycles"
                name="cycles"
                data-cy="cycles"
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.cycles')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentCycles
                  ? treatmentCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-adverse-event-eventType"
                name="eventType"
                data-cy="eventType"
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.eventType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-adverse-event-eventResult"
                name="eventResult"
                data-cy="eventResult"
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.eventResult')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-adverse-event-regimen"
                name="regimen"
                data-cy="regimen"
                label={translate('tinyMedicRestApp.treatmentAdverseEvent.regimen')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentRegimen
                  ? treatmentRegimen.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-adverse-event" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentAdverseEventUpdate;
